import {Component, OnInit} from '@angular/core';
import {take} from 'rxjs/operators';
import {FirebaseService} from '../../../../../../service/firebase/firebase.service';
import {
  RadiobremenWetterbericht
} from '../../../../../../model/vorhersagen/radiobremen-wetterbericht';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-radiobremen',
  templateUrl: './radiobremen.component.html',
  styleUrls: ['../wetterbericht.component.css']
})
export class RadiobremenComponent implements OnInit {


  radioBremenBericht: RadiobremenWetterbericht;
  selectedIndex: number = 0;
  isLoading = true;

  constructor(private firebaseService: FirebaseService, private snackbar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.loadBerichte();
  }

  loadBerichte() {
    this.isLoading = true;
    this.firebaseService.getTerminalTexteRadioBremen()
      .pipe(take(1))
      .subscribe(querySnapshot => {
        querySnapshot.docs.map(doc => {
          if (doc.id === 'V_TERM_RB_AKTUELL') {
            this.radioBremenBericht = doc.data();
            this.createListen();
          }
        });
      }, error => {
        this.snackbar.open(`ERROR: Konnte Berichte nicht laden ${error}`);
      }).add(() => {
      this.isLoading = false;
    });
  }

  onTabChange($event: MatTabChangeEvent) {

  }

  private createListen() {
    this.createVorhersageListe();
    this.createAussichtenListe();
    this.createRegionsListe();
  }

  private createVorhersageListe() {
    if (this.radioBremenBericht.online.vorhersagen !== undefined) {
      this.radioBremenBericht.online.vorhersagen.vorhersageListe = [this.radioBremenBericht.online.vorhersagen.vorhersageHeute, this.radioBremenBericht.online.vorhersagen.vorhersageKommendeNacht, this.radioBremenBericht.online.vorhersagen.vorhersageMorgen];
    }
    if (this.radioBremenBericht.videotext.vorhersagen !== undefined) {
      this.radioBremenBericht.videotext.vorhersagen.vorhersageListe = [this.radioBremenBericht.videotext.vorhersagen.vorhersageKommendeNacht, this.radioBremenBericht.videotext.vorhersagen.vorhersageMorgen];
    }
  }

  private createAussichtenListe() {
    if (this.radioBremenBericht.online.aussichten !== undefined) {
      this.radioBremenBericht.online.aussichten.aussichtsListe = [this.radioBremenBericht.online.aussichten.tag01, this.radioBremenBericht.online.aussichten.tag02, this.radioBremenBericht.online.aussichten.tag03, this.radioBremenBericht.online.aussichten.tag04, this.radioBremenBericht.online.aussichten.tag05];
    }
    if (this.radioBremenBericht.videotext.aussichten !== undefined) {
      this.radioBremenBericht.videotext.aussichten.aussichtsListe = [this.radioBremenBericht?.videotext?.aussichten?.tag01, this.radioBremenBericht?.videotext?.aussichten?.tag02, this.radioBremenBericht?.videotext?.aussichten?.tag03];
    }
  }

  private createRegionsListe() {
    if (this.radioBremenBericht.ozon.regionen !== undefined) {
      this.radioBremenBericht.ozon.regionen.regionsListe = [this.radioBremenBericht.ozon.regionen.region01, this.radioBremenBericht.ozon.regionen.region02, this.radioBremenBericht.ozon.regionen.region03, this.radioBremenBericht.ozon.regionen.region04];
    }
  }
}
